<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">
        {{ title }}
      </h1>
    </div>
  </div>
</div>

<div
  nz-col
  class="flex flex-row justify-end items-center space-x-3"
  *ngIf="
    config.showResetButton ||
    config.showExportButton ||
    config.showDateFilter ||
    config.showNewExportButton ||
    config.showOldExportButton ||
    config.showConsolidateExportButton
  "
>
  <button
    *ngIf="config.showResetButton"
    (click)="resetAllFilter()"
    nz-button
    nzType="primary"
    class="reset-button"
  >
    Reset Filter
  </button>
  <button
    *ngIf="config.showConsolidateExportButton"
    (click)="openConsolidateExportModal()"
    nz-button
    nzType="default"
  >
    Consolidate Export
  </button>
  <!-- Old single export button (backward compatible) -->
  <button
    *ngIf="
      config.showExportButton &&
      !config.showNewExportButton &&
      !config.showOldExportButton
    "
    (click)="exportDataFn()"
    nz-button
    nzType="primary"
  >
    <span nz-icon nzType="download"></span>
    Export
  </button>

  <!-- New dual export buttons -->
  <button
    *ngIf="config.showNewExportButton && activeTab === 'Pending'"
    (click)="exportDataFn()"
    nz-button
    nzType="primary"
    class="mr-2"
  >
    <span nz-icon nzType="download"></span>
    Export (New Format)
  </button>

  <button
    *ngIf="config.showOldExportButton"
    (click)="exportOldFormatFn()"
    nz-button
    nzType="default"
  >
    <span nz-icon nzType="download"></span>
    Export (Old Format)
  </button>
  <nz-range-picker
    *ngIf="config.showDateFilter"
    [nzFormat]="dateFormat"
    [(ngModel)]="dateRange"
    (ngModelChange)="dateChange($event)"
    nzSize="large"
  ></nz-range-picker>
</div>

<nz-spin [nzSpinning]="spinner" nzTip="Fetching Rewards...">
  <div nz-row>
    <nz-tabset *ngIf="config.showTabs" (nzSelectChange)="onTabChange($event)">
      <nz-tab nzTitle="Complete">
        <nz-table
          [nzBordered]="true"
          [nzData]="gridData"
          [nzSize]="'middle'"
          [nzShowPagination]="true"
          [nzScroll]="{ x: '100%' }"
          [nzTotal]="totalRecords"
          [nzPageSize]="pageSize"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="config.pageSizeOptions || [10, 20, 50, 100]"
          [nzPageIndex]="currentPage"
          (nzPageIndexChange)="nzPageIndexChange($event)"
          (nzPageSizeChange)="nzPageSizeChange($event)"
          nzFrontPagination="false"
          nzTableLayout="fixed"
        >
          <thead>
            <tr>
              <th>
                Expert Name
                <nz-filter-trigger
                  [nzActive]="true"
                  [nzDropdownMenu]="userSelectionMenu"
                >
                  <span nz-icon nzType="filter"></span>
                </nz-filter-trigger>
              </th>
              <th>Duration</th>
              <th>Total Amount</th>
              <th>Paid On</th>
              <th>Transaction Id</th>
              <th>Mode of Payment</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of gridData">
              <td>{{ data.userName }}</td>
              <td>
                {{
                  utils.convertEpochToFormattedDate(data.duration!.start) +
                    "-" +
                    utils.convertEpochToFormattedDate(data.duration!.end)
                }}
              </td>
              <td>
                {{
                  data.debitValue < 0
                    ? "Rs " + -data.debitValue
                    : "Rs " + data.debitValue
                }}
              </td>
              <td>
                {{ utils.convertEpochToFormattedDate(data.date) }}
              </td>
              <td>
                {{ data.transactionId }}
              </td>
              <td>
                {{ data.modeOfPayment }}
              </td>
              <td>
                <button
                  *ngIf="config.enableLedgerView"
                  (click)="openDrawer(data)"
                  nz-button
                  nzType="link"
                >
                  View Ledger
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
      <nz-tab nzTitle="Pending">
        <nz-table
          [nzBordered]="true"
          [nzData]="gridData"
          [nzSize]="'middle'"
          [nzShowPagination]="false"
          [nzScroll]="{ x: '100%' }"
          nzTableLayout="fixed"
        >
          <thead>
            <tr>
              <th>
                Expert Name
                <nz-filter-trigger
                  [nzActive]="true"
                  [nzDropdownMenu]="userSelectionMenu"
                >
                  <span nz-icon nzType="filter"></span>
                </nz-filter-trigger>
              </th>
              <th>Duration</th>
              <th>Total Amount Pending</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of gridData">
              <td>{{ data.userName }}</td>
              <td>
                {{
                  utils.convertEpochToFormattedDate(data.duration!.start) +
                    "-" +
                    utils.convertEpochToFormattedDate(data.duration!.end)
                }}
              </td>
              <td>
                {{
                  "Rs " +
                    (data.creditValue === 0
                      ? data.debitValue
                      : data.creditValue)
                }}
              </td>
              <td>
                <button
                  *ngIf="config.enableLedgerView"
                  (click)="openDrawer(data)"
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  class="m-3"
                >
                  View Ledger
                </button>
                <button
                  *ngIf="config.enablePayments"
                  (click)="openPaymentModal(data.userId, data.duration)"
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  class="m-3"
                >
                  Pay Now
                </button>
                <button
                  *ngIf="config.enableAddReward"
                  (click)="openAddRewardModal(data.userId)"
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  class="m-3"
                >
                  Add Reward
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
      <nz-tab nzTitle="All">
        <nz-table
          [nzBordered]="true"
          [nzData]="gridData"
          [nzSize]="'middle'"
          [nzShowPagination]="true"
          [nzScroll]="{ x: '100%' }"
          [nzTotal]="totalRecords"
          [nzPageSize]="pageSize"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="config.pageSizeOptions || [10, 20, 50, 100]"
          [nzPageIndex]="currentPage"
          (nzPageIndexChange)="nzPageIndexChange($event)"
          (nzPageSizeChange)="nzPageSizeChange($event)"
          nzFrontPagination="false"
          nzTableLayout="fixed"
        >
          <thead>
            <tr>
              <th>
                Name
                <nz-filter-trigger
                  [nzActive]="true"
                  [nzDropdownMenu]="userSelectionMenu"
                >
                  <span nz-icon nzType="filter"></span>
                </nz-filter-trigger>
              </th>
              <th>
                Reward Type
                <nz-filter-trigger
                  *ngIf="config.tableType === 'CIRCLE_REWARDS'"
                  [nzActive]="true"
                  [nzDropdownMenu]="rewardSelectionMenu"
                >
                  <span nz-icon nzType="filter"></span>
                </nz-filter-trigger>
              </th>
              <th *ngIf="config.showSessionDetails">Session details</th>
              <th>Date</th>
              <th>
                Transaction Type
                <nz-filter-trigger
                  [nzActive]="true"
                  [nzDropdownMenu]="transactionTypeMenu"
                >
                  <span nz-icon nzType="filter"></span>
                </nz-filter-trigger>
              </th>
              <th>Amount</th>
              <th>Transaction Id</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of gridData; index as i">
              <td>{{ data.userName }}</td>
              <td>{{ data.description }}</td>
              <td *ngIf="config.showSessionDetails">
                <div [innerHTML]="getSessionDetailsText(data)"></div>
              </td>

              <td>{{ utils.convertEpochToFormattedDate(data.date) }}</td>
              <td>{{ data.debitValue < 0 ? "Debit" : "Credit" }}</td>
              <td>
                {{
                  data.debitValue < 0
                    ? "Rs " + data.debitValue
                    : "Rs " + data.creditValue
                }}
              </td>
              <td>{{ data.transactionId }}</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
    </nz-tabset>

    <!-- Single table when tabs are disabled -->
    <nz-table
      *ngIf="!config.showTabs"
      [nzBordered]="true"
      [nzData]="gridData"
      [nzSize]="'middle'"
      [nzShowPagination]="true"
      [nzScroll]="{ x: '100%' }"
      [nzTotal]="totalRecords"
      [nzPageSize]="pageSize"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="config.pageSizeOptions || [10, 20, 50, 100]"
      [nzPageIndex]="currentPage"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
      nzFrontPagination="false"
      nzTableLayout="fixed"
    >
      <thead>
        <tr>
          <th>Name</th>
          <th>Reward Type</th>
          <th>Date</th>
          <th>Transaction Type</th>
          <th>Amount</th>
          <th>Transaction Id</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of gridData">
          <td>{{ data.userName }}</td>
          <td>{{ data.description }}</td>
          <td>{{ utils.convertEpochToFormattedDate(data.date) }}</td>
          <td>{{ data.debitValue < 0 ? "Debit" : "Credit" }}</td>
          <td>
            {{
              data.debitValue < 0
                ? "Rs " + data.debitValue
                : "Rs " + data.creditValue
            }}
          </td>
          <td>{{ data.transactionId }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>

<!-- Drawer for Ledger View -->
<nz-drawer
  *ngIf="config.enableLedgerView"
  [nzVisible]="isDrawerVisible"
  [nzPlacement]="'bottom'"
  [nzHeight]="'500px'"
  [nzClosable]="true"
  (nzOnClose)="closeDrawer()"
  nzTitle="Expert Reward Ledger"
>
  <ng-container *nzDrawerContent>
    <nz-spin [nzSpinning]="spinner" nzSize="large">
      <div class="mb-2 w-full flex justify-end">
        <button
          *ngIf="config.showExportButton"
          (click)="exportViewLedger()"
          nz-button
          nzType="primary"
        >
          <span nz-icon nzType="download"></span>
          Export
        </button>
      </div>
      <nz-table
        [nzBordered]="true"
        [nzData]="viewLedgerGridData"
        [nzSize]="'middle'"
        [nzShowPagination]="false"
        [nzScroll]="{ x: '100%' }"
      >
        <thead>
          <tr>
            <th>Date</th>
            <th *ngIf="config.showSessionDetails">Session details</th>
            <th>Reward Type</th>
            <th>Amount</th>
            <th>Transaction Id</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of viewLedgerGridData; index as i">
            <td>{{ utils.convertEpochToFormattedDate(data.date) }}</td>
            <td *ngIf="config.showSessionDetails">
              <div [innerHTML]="getSessionDetailsText(data)"></div>

              <div *ngIf="data.sessionTags && data.sessionTags.length">
                <nz-tag
                  *ngFor="let tag of data.sessionTags"
                  [nzColor]="tag.value"
                >
                  {{ tag.label }}
                </nz-tag>
              </div>
            </td>
            <td>
              <a
                class="underline"
                role="button"
                tabindex="0"
                (click)="navigateToSessions(data.description)"
                (keyup.enter)="navigateToSessions(data.description)"
                >{{ data.description }}</a
              >
            </td>
            <td>
              {{
                "Rs " +
                  (data.creditValue === 0 ? data.debitValue : data.creditValue)
              }}
            </td>
            <td>{{ data.transactionId }}</td>
          </tr>
        </tbody>
      </nz-table>
    </nz-spin>
  </ng-container>
</nz-drawer>

<nz-modal
  [(nzVisible)]="isConsolidateExportModalVisible"
  [nzFooter]="null"
  (nzOnCancel)="closeConsolidateExportModal()"
  nzTitle="Consolidate export"
>
  <ng-container *nzModalContent>
    <p class="mb-3">
      Select date range (transfer date, Asia/Kolkata day bounds).
    </p>
    <nz-range-picker
      class="w-full mb-4"
      [(ngModel)]="consolidateExportDateRange"
      [nzFormat]="dateFormat"
      nzSize="large"
      [nzDisabledDate]="disableConsolidateDatesAfterToday"
    ></nz-range-picker>
    <div class="flex flex-row justify-end gap-2">
      <button
        nz-button
        nzType="default"
        type="button"
        (click)="closeConsolidateExportModal()"
      >
        Cancel
      </button>
      <button
        nz-button
        nzType="primary"
        type="button"
        [nzLoading]="consolidateExportLoading"
        [disabled]="consolidateExportDateRange.length !== 2"
        (click)="submitConsolidateExport()"
      >
        Download CSV
      </button>
    </div>
  </ng-container>
</nz-modal>

<!-- Payment Modal -->
<nz-modal
  *ngIf="config.enablePayments"
  [(nzVisible)]="isPaymentModalVisible"
  [nzFooter]="null"
  (nzOnCancel)="closePaymentModal()"
  nzTitle="Make Payment"
>
  <ng-container *nzModalContent>
    <form
      [formGroup]="paymentForm"
      (ngSubmit)="submitPaymentForm()"
      class="flex flex-col space-y-3"
    >
      <nz-form-item>
        <nz-form-label [nzSpan]="6">From Date</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-date-picker
            formControlName="fromDate"
            [nzDisabledDate]="disableFutureDates"
            nzFormat="yyyy-MM-dd"
            class="w-full"
          ></nz-date-picker>
          <div
            *ngIf="
              paymentForm.controls['fromDate'].invalid &&
              paymentForm.controls['fromDate'].touched
            "
            class="error-text"
          >
            From date is required.
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="6">To Date</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-date-picker
            formControlName="toDate"
            [nzDisabledDate]="disableFutureDates"
            nzFormat="yyyy-MM-dd"
            class="w-full"
          ></nz-date-picker>
          <div
            *ngIf="
              paymentForm.controls['toDate'].invalid &&
              paymentForm.controls['toDate'].touched
            "
            class="error-text"
          >
            To date is required.
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="6">Amount</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input
            nz-input
            [readonly]="true"
            formControlName="amount"
            type="number"
            placeholder="Enter amount"
            class="bg-gray-100 text-gray-500 cursor-not-allowed border border-gray-300 rounded px-3 py-2 w-full"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6">Transaction ID</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input
            nz-input
            formControlName="transactionId"
            type="text"
            placeholder="Enter transaction ID"
            class="input-field"
          />
          <div
            *ngIf="
              paymentForm.controls['transactionId'].invalid &&
              paymentForm.controls['transactionId'].touched
            "
            class="error-text"
          >
            Transaction ID is required.
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="6">Mode of Payment</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <input
            nz-input
            formControlName="modeOfPayment"
            type="text"
            placeholder="Enter mode of payment (e.g. Online or Offline)"
            class="input-field"
          />
          <div
            *ngIf="
              paymentForm.controls['modeOfPayment'].invalid &&
              paymentForm.controls['modeOfPayment'].touched
            "
            class="error-text"
          >
            Mode of payment is required.
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="flex flex-row justify-end">
        <nz-form-control>
          <button
            [disabled]="paymentForm.invalid"
            nz-button
            nzType="primary"
            type="submit"
            class="submit-button ml-3"
          >
            Submit
          </button>
          <button
            (click)="closePaymentModal()"
            nz-button
            nzType="default"
            type="button"
          >
            Cancel
          </button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<!-- Add Reward Modal -->
<nz-modal
  *ngIf="config.enableAddReward"
  [(nzVisible)]="isAddRewardModalVisible"
  [nzFooter]="null"
  (nzOnCancel)="closeAddRewardModal()"
  nzTitle="Add Reward"
>
  <nz-spin
    [nzSpinning]="isAddRewardLoading"
    nzSize="large"
    nzTip="Submitting..."
  >
    <ng-container *nzModalContent>
      <form
        [formGroup]="addRewardForm"
        (ngSubmit)="submitAddRewardForm()"
        class="flex flex-col space-y-3"
      >
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Amount</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <input
              nz-input
              formControlName="amount"
              type="number"
              placeholder="Enter amount"
              class="input-field"
            />
            <div
              *ngIf="
                addRewardForm.controls['amount'].invalid &&
                addRewardForm.controls['amount'].touched
              "
              class="error-text"
            >
              Amount is required.
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Transaction Direction</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-select
              formControlName="transactionDirection"
              placeholder="Select direction"
              class="w-full input-field"
            >
              <nz-option nzValue="Debit" nzLabel="Debit (-)"></nz-option>
              <nz-option nzValue="Credit" nzLabel="Credit (+)"></nz-option>
            </nz-select>
            <div
              *ngIf="
                addRewardForm.controls['transactionDirection'].invalid &&
                addRewardForm.controls['transactionDirection'].touched
              "
              class="error-text"
            >
              Transaction direction is required.
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Description</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea
              nz-input
              formControlName="description"
              rows="3"
              placeholder="Enter description"
              class="input-field"
            ></textarea>
            <div
              *ngIf="
                addRewardForm.controls['description'].invalid &&
                addRewardForm.controls['description'].touched
              "
              class="error-text"
            >
              Description is required.
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="flex flex-row justify-end gap-3">
          <nz-form-control>
            <button
              [disabled]="addRewardForm.invalid || isAddRewardLoading"
              nz-button
              nzType="primary"
              type="submit"
              class="submit-button ml-3"
            >
              {{ isAddRewardLoading ? "Submitting..." : "Submit" }}
            </button>
            <button
              [disabled]="isAddRewardLoading"
              (click)="closeAddRewardModal()"
              nz-button
              nzType="default"
              type="button"
            >
              Cancel
            </button>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-spin>
</nz-modal>

<!-- Filter Dropdowns -->
<nz-dropdown-menu #transactionTypeMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Transaction Type</span>
        <nz-divider></nz-divider>
        <nz-radio-group [(ngModel)]="selectedTransactionType">
          <div *ngFor="let option of transactionFilterOption" nz-row>
            <div nz-col>
              <label [nzValue]="option" nz-radio>{{ option }}</label>
            </div>
          </div>
        </nz-radio-group>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          (click)="getAllOrPendingGridData()"
          class="m-1"
          nz-button
          nzType="primary"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          (click)="resetFilterAndFetchData('TRANSACTION_TYPE')"
          class="m-1"
          nz-button
          nzType="primary"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #userSelectionMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Select User</span>
        <nz-divider></nz-divider>

        <div nz-row class="mb-2">
          <div nz-col>
            <label class="mr-2">Include Test Experts</label>
            <nz-switch
              [ngModel]="includeTestExperts"
              (ngModelChange)="toggleIncludeTestExperts($event)"
              [nzCheckedChildren]="'true'"
              [nzUnCheckedChildren]="'false'"
            ></nz-switch>
          </div>
        </div>

        <div class="max-h-64 overflow-y-auto">
          <nz-radio-group [(ngModel)]="selectedUserId">
            <div *ngFor="let user of expertOptions" nz-row>
              <div nz-col>
                <label [nzValue]="user" nz-radio>{{ user.userName }}</label>
              </div>
            </div>
          </nz-radio-group>
        </div>
      </div>
    </div>

    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          (click)="onSubmitFilterAndFetchData()"
          class="m-1"
          nz-button
          nzType="primary"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          (click)="resetFilterAndFetchData('USER_ID')"
          class="m-1"
          nz-button
          nzType="default"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #rewardSelectionMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Select Reward Type</span>
        <nz-divider></nz-divider>
        <nz-radio-group [(ngModel)]="selectedRewardType">
          <div *ngFor="let reward of rewardTypeFilter" nz-row>
            <div nz-col>
              <label [nzValue]="reward" nz-radio>{{ reward }}</label>
            </div>
          </div>
        </nz-radio-group>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          (click)="onSubmitFilterAndFetchData()"
          class="m-1"
          nz-button
          nzType="primary"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          (click)="resetFilterAndFetchData('REWARD_TYPE')"
          class="m-1"
          nz-button
          nzType="default"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
